import { StyledModal } from '@app/components/modal/Modal';
import { UserForm } from './UserForm';
import type { ModalProps } from 'antd';
import type { RoleOption, User } from '@app/services/api.types';
import useUserActions from '@app/hooks/users/useUserActions';

export type UserEditModalProps = ModalProps & {
    title?: string;
    data?: User;
    roles?: RoleOption[];
};

export const UserEditModal = ({
    title = 'Edit User',
    roles = [],
    data,
    ...props
}: UserEditModalProps) => {
    const { editUser } = useUserActions();

    return (
        <StyledModal title={title} maskClosable={false} {...props} footer={null}>
            <UserForm
                data={data}
                roles={roles}
                isEdit={true}
                onCancel={props.onCancel}
                confirmLoading={editUser.isPending}
                onSubmit={(values) => {
                    const userId = data?.id?.toString() || '';
                    const formData = {
                        ...values,
                        id: userId,
                    };
                    editUser.mutate(formData, {
                        onSuccess: () => {
                            if (props?.onOk) {
                                props.onOk(
                                    undefined as unknown as React.MouseEvent<HTMLButtonElement>
                                );
                            }
                        },
                    });
                }}
            />
        </StyledModal>
    );
};
